import Skeleton, { SkeletonShape } from "@/shared/ui/components/skeleton";
import CircularProgress from "@mui/material/CircularProgress";

const LoadingPage = ({
  title,
  message,
}: {
  title: string;
  message: string;
}) => (
  <div className="grow flex flex-col p-3 relative">
    <div className="flex flex-col gap-10 py-5">
      <div>
        <Skeleton shape={SkeletonShape.LINES} width={40} />
      </div>
      <div>
        <div className="bg-[#f9f9f9] h-30 rounded-4xl"></div>
      </div>
    </div>
    <div
      className="absolute top-0 left-0 w-full h-full flex flex-col items-center justify-center"
      style={{
        background: "#ffffff00",
        backdropFilter: "blur(12px)",
      }}
    >
      <div>
        <div className="m-auto text-center mb-3">
          <CircularProgress size={39} style={{ color: "#9600F1" }} />
        </div>
        <div className="text-[24px] font-semibold text-gray-900 mb-2 text-center">
          {title}
        </div>
        <div className="text-[#585B7A] text-center">{message}</div>
      </div>
    </div>
  </div>
);

export default LoadingPage;
